import { FinancialsStatus } from "./financials-response.interface";

export interface CreateFinancialsInterface {
  annual_sales_target: number;
  status: FinancialsStatus;
  created_by_id: string | null;
  updated_by_id: string | null;
}

export interface UpdateFinancialsInterface {
  id: string;
  annual_sales_target?: number;
  status?: FinancialsStatus;
  updated_by_id: string | null;
}